export default function LogoIntenser({
  className,
  onClick,
}: {
  className?: string;
  onClick?: () => void;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 200"
      onClick={onClick}
      className={className}
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="M200.392 53.6895C274.638 16.0123 357.558 -7.75798 383.628 2.32129C431.369 20.7641 365.452 71.0435 333.916 83.5586C364.388 29.5384 303.673 43.9791 240.37 75.9531C287.675 104.947 325.153 138.774 331.507 170.942C340.704 218.147 261.865 197.948 234.052 178.407C309.4 183.708 263.928 137.277 200.473 98.248C136.991 137.277 91.4732 183.708 166.82 178.407C139.226 198.167 60.1681 218.147 69.366 170.942C75.6424 138.755 113.139 104.907 160.489 75.9014C97.241 43.964 36.5981 29.5678 66.9568 83.5586C35.4211 71.0437 -30.4965 20.9837 17.2449 2.32129C43.315 -7.75781 126.172 16.0125 200.392 53.6895Z"
        fill="currentColor"
      />
    </svg>
  );
}
